import script from "./AdOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./AdOverlay.vue?vue&type=script&setup=true&lang=js"

import "./AdOverlay.vue?vue&type=style&index=0&id=ec914b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec914b4a"]])

export default __exports__